import { Suspense, lazy } from "react";
import { useSprint26FlagVisible } from "../lib/featureFlags.js";

/**
 * E-BUNDLE-14 — Ladeschranke vor dem Help-Drawer. Siehe
 * `search/GlobalSearchPaletteGate.tsx` fuer die Begruendung: das Flag
 * `sprint26.guidedTour` ist `internal_admin_only` und Default OFF, und es
 * steht erst nach einem Netz-Roundtrip fest. Bis dahin zeichnete der Drawer
 * ohnehin nichts — er lag nur mit rund 2,9 kB generiertem Code im
 * Entry-Chunk.
 */
const HelpDrawer = lazy(async () => {
  const mod = await import("./HelpDrawer.js");
  return { default: mod.HelpDrawer };
});

export function HelpDrawerGate() {
  const { visible } = useSprint26FlagVisible("sprint26.guidedTour");
  if (!visible) return null;
  return (
    <Suspense fallback={null}>
      <HelpDrawer />
    </Suspense>
  );
}
